import {
  TextField,
  Button,
  DialogActions,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Close, Check } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { Load, toggleEditStoreInfoDialog } from "../redux/GlobalStates";
import { useState } from "react";
import { request } from "../request";
import { LoginSuccess } from "../redux/login";
export default function EditStoreInfo({ open, handleClose }) {
  const store = useSelector((state) => state.store.Store);
  const dispatch = useDispatch();
  const toggleDialog = () => dispatch(toggleEditStoreInfoDialog());
  const [storeInfo, setStoreInfo] = useState({
    name: store?.name,
    email: store?.email,
    phone: store?.phone,
    location: store?.location,
  });
  // const handle store edit
  const handleStoreInfoEdit = async () => {
    dispatch(Load());
    try {
      const res = await request.put(`/store/info?id=${store?.id}`, {
        storeInfo,
      });
      dispatch(LoginSuccess({ ...store, ...storeInfo }));
      alert(res.data);
      toggleDialog();
    } catch (err) {
      alert(err?.message || "Network error");
    }
    dispatch(Load());
  };
  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle className="dial-heading">Edit Store Info</DialogTitle>
        <DialogContent>
          <DialogContentText>Kindly fill all fields</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Store name"
            value={storeInfo?.name}
            type="text"
            fullWidth
            variant="outlined"
            className="dial-input"
            onChange={(e) =>
              setStoreInfo((prev) => ({ ...prev, name: e.target.value }))
            }
          />
          <TextField
            margin="dense"
            label="Store Location"
            type="text"
            fullWidth
            value={storeInfo?.location}
            variant="outlined"
            className="dial-input"
            onChange={(e) =>
              setStoreInfo((prev) => ({ ...prev, location: e.target.value }))
            }
          />
          <TextField
            margin="dense"
            onChange={(e) =>
              setStoreInfo((prev) => ({
                ...prev,
                phone: e.target.value,
              }))
            }
            label="Phone"
            type="text"
            value={storeInfo?.phone}
            fullWidth
            variant="outlined"
            className="dial-input"
          />
          <TextField
            margin="dense"
            onChange={(e) =>
              setStoreInfo((prev) => ({
                ...prev,
                email: e.target.value,
              }))
            }
            label="Email"
            type="text"
            value={storeInfo?.email}
            fullWidth
            variant="outlined"
            className="dial-input"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => toggleDialog()}>
            <Close className="dial-icon cancel" />
          </Button>
          <Button onClick={handleStoreInfoEdit}>
            <Check />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
